import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { TaskExecutionReportComponent } from "./task-execution-report/task-execution-report.component";
import { RunnersReportComponent } from "./runners-report/runners-report.component";
import { TasksReportComponent } from "./tasks-report/tasks-report.component";
import { ReportsComponent } from "./reports.component";
import { AuthGuard } from "../services/permission/permissions.service";
import { MailReportComponent } from "./mail-report/mail-report.component";
import { AuditReportComponent } from "./audit-report/audit-report.component";
import { MailTemplatesComponent } from "./mail-templates/mail-templates.component";


const routes: Routes = [
  {
    path: "reports",
    component: ReportsComponent,

    children: [
      {
        path: "task-execution-report",
        component: TaskExecutionReportComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "runners-report",
        component: RunnersReportComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "tasks-report",
        component: TasksReportComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "audit-report",
        component: AuditReportComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "mail-report",
        component: MailReportComponent,
        canActivate: [AuthGuard]
      },
      {
        path: "mail-templates",
        component: MailTemplatesComponent,
        canActivate: [AuthGuard]
      }

    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule {}
